import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const CustomTableHeader = ({ title, tableId }: { title: string; tableId: number }) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  return (
    <ResourceHeader
      title={title}
      otherActions={[
        {
          label: i18n.t('settings.custom_table.details.destroy'),
          critical: true,
          onClick: () =>
            navigate(
              navigation.settings.customizations.customTablesId.destroy.fullPath({ id: tableId })
            ),
        },
      ]}
    />
  )
}
